export enum AssignmentDetailsReturnLocationEnum {
    Past = 'past',
}
